import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";

import { blog, stories } from "../../../assets/image";
import { useAppMutation, useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { CREATED_CATEGORY, DELETE_CETEGORY, GET_CATEGORIES, UPDATE_CATEGORY } from "../../../api/url";
import DeletModel from "../../model/DeletModel";
import { CategoryList } from "../../../components/categoryComponents/CategoryList";
import { EditCategoryModal } from "../../../components/categoryComponents/EditCategoryModal";
import { CreateCategory } from "../../../components/categoryComponents/CreateCategory";
import { strings } from "../../../strings/strings";
import Loader from "../../../components/common/Loader";
import { toast } from "react-toastify";

export const Category = () => {
  const [activeTab, setActiveTab] = useState("blog");
  const [selectedCategory, setSelectedCategory] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);

  const { mutate: deleteCategory } = useAppMutation();
  const { mutate: editCategory } = useAppMutation();
  const { mutate: addCreateCateogry } = useAppMutation();

  const tabs = [
    { key: "blog", label: "Blogs", image: blog },
    { key: "story", label: "Stories", image: stories },
  ];

  const { data, isLoading, refetch, isRefetching } = useAppQuery({
    queryKey: [QUERY_KEYS.CATEGORIES, activeTab],
    url: `${GET_CATEGORIES}?type=${activeTab}`,
  });

  if (!!isLoading || isRefetching) {
    return <Loader />;
  }

  const onClose = () => {
    setSelectedCategory("");
    setShowEditModal(false);
  };
  const onSave = (formData) => {
    editCategory(
      {
        url: `${UPDATE_CATEGORY}?categoryId=${selectedCategory._id}`,
        method: "PUT",
        data: formData,
      },
      {
        onSuccess: () => {
          setShowEditModal(false);
          toast.success(strings.categoryUpdateSuccess);
          setTimeout(() => {
            refetch();
          }, 2000);
        },
      }
    );
  };

  const onSaveCategory = (formData) => {

    addCreateCateogry(
      {
        url: CREATED_CATEGORY,
        method: "POST",
        data: formData,
      },
      {
        onSuccess: () => {
          toast.success(strings.categoryCreateSuccessfully);
          setShowCreateCategoryModal(false);
          setTimeout(() => {
            refetch();
          }, 2000);
        },
      }
    );
  };

  const handleEdit = (val) => {
    setSelectedCategory(val);
    setShowEditModal(true);
  };

  const handleDelete = (val) => {
    setSelectedCategory(val);
    setShowModal(true);
  };

  const handleCancelDelete = () => {
    setShowModal(false);
    setSelectedCategory(null);
  };

  const handleConfirmDelete = async () => {
    deleteCategory(
      {
        url: `${DELETE_CETEGORY}?categoryId=${selectedCategory._id}`,

        method: "DELETE",
      },
      {
        onSuccess: () => {
          toast.success(strings.categorydeleteSuccessfully);
          setShowModal(false);
          setTimeout(() => {
            refetch();
            setSelectedCategory("");
          }, 2000);
        },
        onError: (error) => {
          console.error("Delete Error", error);
          toast.error(strings.failToDeleteCategory);
        },
      }
    );
  };

  const onPressAddCategory = () => setShowCreateCategoryModal(true);
  const onCreateCancel = () => setShowCreateCategoryModal(false);

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-primary">Category</h1>
          <p className="mt-2 text-sm text-gray-700 capitalize">All list of category blogs and stories</p>
        </div>
      </div>
      <div className="w-full max-w-3xl mx-auto">
        <div className="grid sm:flex justify-between border-b mb-3">
          <div className="flex gap-4">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-4 px-3 sm:px-8 lg:px-14 py-3 rounded-t-md transition-all duration-200 ${
                  activeTab === tab.key
                    ? "bg-white border border-b-0 border-gray-300 shadow-sm font-semibold"
                    : "text-grey hover:text-dark"
                }`}
              >
                <img className="w-7 h-7" src={tab.image} alt="" />
                {tab.label}
              </button>
            ))}
          </div>
          <div className="flex justify-between items-center ">
            <button
              onClick={onPressAddCategory}
              className="bg-primary text-white px-4 py-2 rounded hover:bg-[#00008B] transition"
            >
              + Add Category
            </button>
          </div>
        </div>

        <CategoryList data={data?.results} handleEdit={handleEdit} handleDelete={handleDelete} />
        {showModal && <DeletModel handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />}
        {!!showEditModal && <EditCategoryModal category={selectedCategory} onSave={onSave} onClose={onClose} />}
        {!!showCreateCategoryModal && <CreateCategory onClose={onCreateCancel} onSave={onSaveCategory} />}
      </div>
    </div>
  );
};
